import { useMutation } from "@tanstack/react-query";
import { updateSettings, UpdateSettingsParams } from "@/api/settings";
import { Settings } from "@/types/Settings";

export interface UpdateSettingsOptions {
  onSuccess?: (data: Settings) => void;
  onError?: (error: Error) => void;
}

export const useUpdateSettings = (options?: UpdateSettingsOptions) => {
  return useMutation({
    mutationFn: (params: UpdateSettingsParams) => updateSettings(params),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
};
